// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Hur3","right":"Footer_right__16JYR","buttons":"Footer_buttons__1Zlr6"};